import React from "react";
import { Table } from "semantic-ui-react";
import { Trades } from "../../types";

interface Props {
  tradeData: Trades[] | undefined;
}

const TradeTable = ({ tradeData }: Props) => {
  return (
    <div>
      <Table id="misbilled-table">
        <Table.Header id="table-header">
          <Table.Row id="table-header-row">
            <Table.HeaderCell>Id</Table.HeaderCell>
            <Table.HeaderCell>Account Number</Table.HeaderCell>
            <Table.HeaderCell>Account Type</Table.HeaderCell>
            <Table.HeaderCell>Symbol</Table.HeaderCell>
            <Table.HeaderCell>Price</Table.HeaderCell>
            <Table.HeaderCell>Quantity</Table.HeaderCell>
            <Table.HeaderCell>Strike Price</Table.HeaderCell>
            <Table.HeaderCell>Expiry</Table.HeaderCell>
            <Table.HeaderCell>Pc Indicator</Table.HeaderCell>
            <Table.HeaderCell>Side</Table.HeaderCell>
            <Table.HeaderCell>Open/Close</Table.HeaderCell>
            <Table.HeaderCell>Clearing Firm</Table.HeaderCell>
            <Table.HeaderCell>Trade Status</Table.HeaderCell>
            <Table.HeaderCell>Trade Date</Table.HeaderCell>
            <Table.HeaderCell>Transaction Time</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {tradeData &&
            tradeData?.map((trade) => (
              <Table.Row key={trade.id}>
                <Table.Cell key={`${trade.id}-id`} id={`table-${trade.id}-id`}>
                  {trade.id}
                </Table.Cell>
                <Table.Cell
                  key={`${trade.id}-accountNumber`}
                  id={`table-${trade.id}-accountNumber`}
                >
                  {trade.accountNumber}
                </Table.Cell>
                <Table.Cell
                  key={`${trade.id}-accountType`}
                  id={`table-${trade.id}-accountType`}
                >
                  {trade.accountType}
                </Table.Cell>
                <Table.Cell
                  key={`${trade.id}-symbol`}
                  id={`table-${trade.id}-symbol`}
                >
                  {trade.symbol}
                </Table.Cell>
                <Table.Cell
                  key={`${trade.id}-price`}
                  id={`table-${trade.id}-price`}
                >
                  {trade.price}
                </Table.Cell>
                <Table.Cell
                  key={`${trade.id}-quantity`}
                  id={`table-${trade.id}-quantity`}
                >
                  {trade.quantity}
                </Table.Cell>
                <Table.Cell
                  key={`${trade.id}-strikePrice`}
                  id={`table-${trade.id}-strikePrice`}
                >
                  {trade.strikePrice}
                </Table.Cell>
                <Table.Cell
                  key={`${trade.id}-expiry`}
                  id={`table-${trade.id}-expiry`}
                >
                  {trade.expiry}
                </Table.Cell>
                <Table.Cell
                  key={`${trade.id}-pcIndicator`}
                  id={`table-${trade.id}-pcIndicator`}
                >
                  {trade.pcIndicator}
                </Table.Cell>
                <Table.Cell
                  key={`${trade.id}-side`}
                  id={`table-${trade.id}-side`}
                >
                  {trade.side}
                </Table.Cell>
                <Table.Cell
                  key={`${trade.id}-openClose`}
                  id={`table-${trade.id}-openClose`}
                >
                  {trade.openClose}
                </Table.Cell>
                <Table.Cell
                  key={`${trade.id}-clearingFirm`}
                  id={`table-${trade.id}-clearingFirm`}
                >
                  {trade.clearingFirm}
                </Table.Cell>
                <Table.Cell
                  key={`${trade.id}-tradeStatus`}
                  id={`table-${trade.id}-tradeStatus`}
                >
                  {trade.tradeStatus}
                </Table.Cell>
                <Table.Cell
                  key={`${trade.id}-insertTime`}
                  id={`table-${trade.id}-insertTime`}
                >
                  {trade.insertTime}
                </Table.Cell>
                <Table.Cell
                  key={`${trade.id}-transactionTime`}
                  id={`table-${trade.id}-transactionTime`}
                >
                  {trade.transactionTime}
                </Table.Cell>
              </Table.Row>
            ))}
        </Table.Body>
      </Table>
    </div>
  );
};

export default TradeTable;
